import { RouterViewComponent } from '~packages/epk-front-shared/lib';

import { accessRoutes } from '../access';
import { accountsRoutes } from '../accounts';
import { aggReportsRoutes } from '../agg-reports';
import { basketRoutes } from '../basket';
import { epguRoutes } from '../epgu';
import { epkRoutes } from '../epk';
import { epkReportsRoutes } from '../epk-reports';
import { extractRoutes } from '../extract';
import { headRoutes } from '../head';
import { lphRoutes } from '../lph';
import { orgRoutes } from '../org';

[accessRoutes, orgRoutes].forEach(arr => {
  arr.forEach(i => {
    const meta = (i.meta ??= {});
    meta.always = true;
  });
});

[headRoutes, lphRoutes, extractRoutes, epguRoutes, basketRoutes].forEach(
  arr => {
    arr.forEach(i => {
      const meta = (i.meta ??= {});
      meta.readWriteOnly = true;
    });
  }
);

export const routes = [
  ...accessRoutes,
  ...accountsRoutes,
  ...aggReportsRoutes,
  ...epguRoutes,
  ...epkRoutes,
  ...epkReportsRoutes,
  ...extractRoutes,
  ...headRoutes,
  ...lphRoutes,
  ...orgRoutes,
  ...basketRoutes,
  {
    path: '/__app-info',
    component: RouterViewComponent,
    children: [
      {
        path: '',
        name: 'AppInfo',
        component: () => import('@/pages/AppInfoPage'),
      },
    ],
  },
];
